import { IconProps, Icon } from '@bnb-chain/space';

export function MetaMaskIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <rect width="24" height="24" fill="#FFE8CB" />
      <path d="M18.753 4.62524L12.9 8.9723L13.9824 6.4076L18.753 4.62524Z" fill="#E2761B" />
      <path d="M5.24119 4.62525L11.0471 9.01348L10.0177 6.4076L5.24119 4.62525Z" fill="#E4761B" />
      <path
        d="M16.6471 14.7017L15.0883 17.09L18.4236 18.0076L19.3824 14.7547L16.6471 14.7017Z"
        fill="#E4761B"
      />
      <path
        d="M4.6235 14.7547L5.57644 18.0076L8.91173 17.09L7.35291 14.7017L4.6235 14.7547Z"
        fill="#E4761B"
      />
      <path
        d="M8.72349 10.6664L7.79408 12.0723L11.1058 12.2194L10.9882 8.66055L8.72349 10.6664Z"
        fill="#E4761B"
      />
      <path
        d="M15.2706 10.6664L12.9765 8.61937L12.9 12.2194L16.2059 12.0723L15.2706 10.6664Z"
        fill="#E4761B"
      />
      <path d="M8.91173 17.09L10.9 16.1194L9.18236 14.7782L8.91173 17.09Z" fill="#E4761B" />
      <path d="M13.0941 16.1194L15.0883 17.09L14.8118 14.7782L13.0941 16.1194Z" fill="#E4761B" />
      <path
        d="M15.0883 17.09L13.0941 16.1194L13.253 17.4194L13.2354 17.9664L15.0883 17.09Z"
        fill="#D7C1B3"
      />
      <path
        d="M8.91173 17.09L10.7648 17.9664L10.753 17.4194L10.9 16.1194L8.91173 17.09Z"
        fill="#D7C1B3"
      />
      <path d="M10.7941 13.9194L9.13526 13.4311L10.3058 12.8958L10.7941 13.9194Z" fill="#233447" />
      <path d="M13.2 13.9194L13.6883 12.8958L14.8647 13.4311L13.2 13.9194Z" fill="#233447" />
      <path d="M8.91173 17.09L9.19411 14.7017L7.35293 14.7547L8.91173 17.09Z" fill="#CD6116" />
      <path d="M14.8058 14.7017L15.0883 17.09L16.647 14.7547L14.8058 14.7017Z" fill="#CD6116" />
      <path
        d="M16.2059 12.0723L12.9 12.2194L13.2059 13.9194L13.6941 12.8958L14.8706 13.4311L16.2059 12.0723Z"
        fill="#CD6116"
      />
      <path
        d="M9.13526 13.4311L10.3117 12.8958L10.7941 13.9194L11.1058 12.2194L7.79408 12.0723L9.13526 13.4311Z"
        fill="#CD6116"
      />
      <path d="M7.79408 12.0723L9.18236 14.7782L9.13526 13.4311L7.79408 12.0723Z" fill="#E4751F" />
      <path d="M14.8706 13.4311L14.8118 14.7782L16.2059 12.0723L14.8706 13.4311Z" fill="#E4751F" />
      <path
        d="M11.1058 12.2194L10.7941 13.9194L11.1824 15.9252L11.2706 13.2841L11.1058 12.2194Z"
        fill="#E4751F"
      />
      <path
        d="M12.9 12.2194L12.7412 13.2782L12.8118 15.9252L13.2059 13.9194L12.9 12.2194Z"
        fill="#E4751F"
      />
      <path
        d="M13.2059 13.9194L12.8118 15.9252L13.0941 16.1194L14.8118 14.7782L14.8706 13.4311L13.2059 13.9194Z"
        fill="#F6851B"
      />
      <path
        d="M9.13526 13.4311L9.18236 14.7782L10.9 16.1194L11.1824 15.9252L10.7941 13.9194L9.13526 13.4311Z"
        fill="#F6851B"
      />
      <path
        d="M13.2354 17.9664L13.253 17.4194L13.1059 17.29H10.8883L10.753 17.4194L10.7648 17.9664L8.91173 17.09L9.55887 17.6194L10.8706 18.5311H13.1236L14.4412 17.6194L15.0883 17.09L13.2354 17.9664Z"
        fill="#C0AD9E"
      />
      <path
        d="M13.0941 16.1194L12.8118 15.9252H11.1824L10.9 16.1194L10.753 17.4194L10.8883 17.29H13.1059L13.253 17.4194L13.0941 16.1194Z"
        fill="#161616"
      />
      <path
        d="M19.0001 9.25466L19.5001 6.85466L18.753 4.62524L13.0942 8.82525L15.2706 10.6664L18.3471 11.5664L19.0295 10.7723L18.7353 10.5605L19.2059 10.1311L18.8412 9.84878L19.3118 9.48995L19.0001 9.25466Z"
        fill="#763D16"
      />
      <path
        d="M4.5 6.85465L5 9.25465L4.68235 9.48995L5.15294 9.84877L4.79412 10.1311L5.26471 10.5605L4.97059 10.7723L5.64706 11.5664L8.72349 10.6664L10.9 8.82524L5.24119 4.62525L4.5 6.85465Z"
        fill="#763D16"
      />
      <path
        d="M18.3471 11.5664L15.2706 10.6664L16.2059 12.0723L14.8118 14.7782L16.647 14.7547L19.3824 14.7547L18.3471 11.5664Z"
        fill="#F6851B"
      />
      <path
        d="M8.72349 10.6664L5.64706 11.5664L4.6235 14.7547L7.35293 14.7547L9.18236 14.7782L7.79408 12.0723L8.72349 10.6664Z"
        fill="#F6851B"
      />
      <path
        d="M12.9 12.2194L13.0942 8.82525L13.9882 6.4076L10.0177 6.4076L10.9 8.82524L11.1058 12.2194L11.1764 13.29L11.1824 15.9252H12.8118L12.8235 13.29L12.9 12.2194Z"
        fill="#F6851B"
      />
      <path
        d="M18.753 4.62524L12.9 8.9723L13.9824 6.4076L18.753 4.62524ZM18.753 4.62524L19.5001 6.85466L19.0001 9.25466L19.3118 9.48995L18.8412 9.84878L19.2059 10.1311L18.7353 10.5605L19.0295 10.7723L18.3471 11.5664M18.753 4.62524L13.0942 8.82525M5.24119 4.62525L11.0471 9.01348L10.0177 6.4076M5.24119 4.62525L10.0177 6.4076M5.24119 4.62525L10.9 8.82524M5.24119 4.62525L4.5 6.85465L5 9.25465L4.68235 9.48995L5.15294 9.84877L4.79412 10.1311L5.26471 10.5605L4.97059 10.7723L5.64706 11.5664M10.0177 6.4076L13.9882 6.4076L13.0942 8.82525M10.0177 6.4076L10.9 8.82524M15.0883 17.09L16.6471 14.7017L19.3824 14.7547M15.0883 17.09L18.4236 18.0076L19.3824 14.7547M15.0883 17.09L13.0941 16.1194M15.0883 17.09L14.8118 14.7782M15.0883 17.09L13.2354 17.9664L13.253 17.4194M15.0883 17.09L14.8058 14.7017L16.647 14.7547M15.0883 17.09L16.647 14.7547M15.0883 17.09L14.4412 17.6194L13.1236 18.5311H10.8706L9.55887 17.6194L8.91173 17.09M19.3824 14.7547L16.647 14.7547M19.3824 14.7547L18.3471 11.5664M4.6235 14.7547L5.57644 18.0076L8.91173 17.09M4.6235 14.7547L7.35291 14.7017L8.91173 17.09M4.6235 14.7547L5.64706 11.5664M4.6235 14.7547L7.35293 14.7547M8.91173 17.09L10.9 16.1194M8.91173 17.09L9.18236 14.7782M8.91173 17.09L10.7648 17.9664L10.753 17.4194M8.91173 17.09L9.19411 14.7017L7.35293 14.7547M8.91173 17.09L7.35293 14.7547M8.72349 10.6664L7.79408 12.0723M8.72349 10.6664L10.9882 8.66055L11.1058 12.2194M8.72349 10.6664L5.64706 11.5664M8.72349 10.6664L10.9 8.82524M7.79408 12.0723L11.1058 12.2194M7.79408 12.0723L9.13526 13.4311M7.79408 12.0723L9.18236 14.7782M11.1058 12.2194L10.7941 13.9194M11.1058 12.2194L11.2706 13.2841L11.1824 15.9252M11.1058 12.2194L10.9 8.82524M11.1058 12.2194L11.1764 13.29L11.1824 15.9252M15.2706 10.6664L12.9765 8.61937L12.9 12.2194M15.2706 10.6664L16.2059 12.0723M15.2706 10.6664L13.0942 8.82525M15.2706 10.6664L18.3471 11.5664M12.9 12.2194L16.2059 12.0723M12.9 12.2194L13.2059 13.9194M12.9 12.2194L12.7412 13.2782L12.8118 15.9252M12.9 12.2194L13.0942 8.82525M12.9 12.2194L12.8235 13.29L12.8118 15.9252M16.2059 12.0723L14.8706 13.4311M16.2059 12.0723L14.8118 14.7782M10.9 16.1194L9.18236 14.7782M10.9 16.1194L10.753 17.4194M10.9 16.1194L11.1824 15.9252M9.18236 14.7782L9.13526 13.4311M9.18236 14.7782L7.35293 14.7547M13.0941 16.1194L14.8118 14.7782M13.0941 16.1194L13.253 17.4194M13.0941 16.1194L12.8118 15.9252M14.8118 14.7782L14.8706 13.4311M14.8118 14.7782L16.647 14.7547M13.253 17.4194L13.1059 17.29H10.8883L10.753 17.4194M10.7941 13.9194L9.13526 13.4311M10.7941 13.9194L10.3058 12.8958L9.13526 13.4311M10.7941 13.9194L10.3117 12.8958L9.13526 13.4311M10.7941 13.9194L11.1824 15.9252M13.2059 13.9194L13.6941 12.8958L14.8706 13.4311M13.2059 13.9194L12.8118 15.9252M13.2059 13.9194L14.8706 13.4311M11.1824 15.9252H12.8118M13.2 13.9194L13.6883 12.8958L14.8647 13.4311L13.2 13.9194Z"
        stroke="#F6851B"
        strokeWidth="0.0672269"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
